/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import { Link } from 'react-router-dom';
import axiosConfig from '../axiosConfig';
import axios from 'axios';


class Footer extends React.Component {

    constructor(props) {
        super(props)

        let appState = localStorage.getItem('appState')
        if (appState) {
            appState = JSON.parse(localStorage.getItem('appState'))
        }

        this.state = {
            isLoggedIn: appState ? appState.isLoggedIn : false,

            // footer-contents
            app_site_url: process.env.REACT_APP_APP_SITE,
            app_site_storage_path: process.env.REACT_APP_APP_SITE_STORAGE_PATH,
            footer_newsletter: {
                title: "",
                description: "",
                email_to: "",
            },
            footer_menus: [],
            footer_social_sites: [],
            footer_payments: [],
            site_logo: "",
            copyright_text: "",

            subscribe_to: "",
            subscribe_text: "subscribe"

        }

        // header-contents
        this.getFooterContents = this.getFooterContents.bind(this)
        this.handleSubscribe = this.handleSubscribe.bind(this)
    }

    getFooterContents() {
        axiosConfig.get("/api/merchant-footer-contents")
            .then(res => {
                if (res.data.success) {
                    let { footer_newsletter, footer_menus, footer_social_sites, logo: site_logo, footer_payments, copyright_text } = res.data.data
                    this.setState({
                        footer_newsletter,
                        footer_menus,
                        footer_social_sites,
                        site_logo,
                        footer_payments,
                        copyright_text,
                    })
                    if (footer_newsletter) {
                        this.state({
                            footer_newsletter
                        })
                    }

                }
            })
            .catch(err => {

            })
    }

    componentDidMount() {
        this.getFooterContents();
    }

    handleSubscribe(e) {
        e.preventDefault();

        this.setState({
            subscribe_text: "subscribing ..."
        })
        let url = "https://api.sendgrid.com/v3/marketing/contacts"
        let data = {

            "list_ids": [

            ],
            "contacts": [
                {
                    "address_line_1": "",
                    "address_line_2": "",
                    "alternate_emails": [
                    ],
                    "city": "",
                    "country": "",
                    "email": this.state.subscribe_to,
                    "first_name": "",
                    "last_name": "",
                    "postal_code": "",
                    "state_province_region": "",
                    "custom_fields": {}
                }
            ]
        }

        axios.put(url, data, {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": `Bearer ${process.env.REACT_APP_SENDGRID_API} `
            }
        }).then(res => {
            if (res.status === 202) {
                this.setState({
                    subscribe_to: "",
                    subscribe_text: "subscribed"
                })
            } else {
                this.setState({
                    subscribe_text: "try again"
                })
            }
        })

    }


    render() {

        let footer_menus_mapping = this.state.footer_menus.map((el, index) => {
            return <li key={el.id} className="text-capitalize">
                <Link to={el.url}>
                    {el.label}
                </Link>
            </li>
        })

        let footer_payments_mapping = this.state.footer_payments.map((el, index) => {
            return <li key={index}><i className={el.icon} /></li>
        })

        let footer_social_sites_mapping = this.state.footer_social_sites.map((el, index) => {
            return <li key={index}>
                <a href={el.url}><i className={el.icon} /></a>
            </li >
        })

        return (
            <div id="footer" className="no-print" >
                <div>
                    <div className="holder holder-subscribe-full lazyload">
                        <div className="circle_decor_wrap">
                            <svg version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 150 150" style={{ enableBackground: 'new 0 0 150 150' }} xmlSpace="preserve" className="circle_decor circle_decor--tl"><defs><filter x={0} y={0} width="100%" height="100%" id="dropshadow_1_003" filterUnits="userSpaceOnUse"><feGaussianBlur in="SourceAlpha" stdDeviation={2} /><feOffset dx={-3} dy={0} result="offsetblur" /><feMerge><feMergeNode /><feMergeNode in="SourceGraphic" /><feMergeNode in="SourceGraphic" /></feMerge></filter><filter x={0} y={0} width="100%" height="100%" id="dropshadow_2_003" filterUnits="userSpaceOnUse"><feGaussianBlur in="SourceAlpha" stdDeviation={2} /><feOffset dx={3} dy={0} result="offsetblur" /><feMerge><feMergeNode /><feMergeNode in="SourceGraphic" /><feMergeNode in="SourceGraphic" /></feMerge></filter><clipPath id="circle_decor_mask_003"><circle r="73.5" cx={75} cy={75} /></clipPath></defs><path fill="#55C1AE" d="M74.933,148.5c-9.9,0-19.533-1.95-28.583-5.783c-8.75-3.699-16.6-9-23.333-15.734c-6.75-6.731-12.034-14.582-15.733-23.332C3.45,94.6,1.5,84.967,1.5,75.066c0-9.9,1.95-19.533,5.783-28.583c3.7-8.75,9-16.6,15.733-23.333S37.6,11.116,46.35,7.417c9.05-3.833,18.684-5.783,28.583-5.783c9.901,0,19.534,1.95,28.584,5.783c8.75,3.7,16.6,9,23.332,15.733c6.733,6.733,12.032,14.583,15.733,23.333c3.832,9.067,5.783,18.684,5.783,28.583c0,9.9-1.951,19.534-5.783,28.584c-3.701,8.75-9,16.6-15.733,23.332c-6.732,6.733-14.582,12.033-23.332,15.733C94.467,146.55,84.834,148.5,74.933,148.5z M75,13.783C41.25,13.783,13.783,41.25,13.783,75S41.25,136.217,75,136.217S136.217,108.75,136.217,75S108.75,13.783,75,13.783z" /><circle r="5.8" cx={75} cy="7.8" fillOpacity="0.25" style={{ filter: 'url(#dropshadow_1_003)' }} clipPath="url(#circle_decor_mask_003)" /><circle r="5.8" cx={74} cy="142.5" fillOpacity="0.25" style={{ filter: 'url(#dropshadow_2_003)' }} clipPath="url(#circle_decor_mask_003)" /><path fill="#55C1AE" d="M81.101,7.712c0,3.346-2.761,6.059-6.164,6.059l0,0c-3.404,0-6.164-2.713-6.164-6.059l0,0c0-3.345,2.76-6.058,6.164-6.058l0,0C78.34,1.654,81.101,4.367,81.101,7.712L81.101,7.712z" /><path fill="#55C1AE" d="M81.177,142.363c0,3.346-2.761,6.06-6.164,6.06l0,0c-3.404,0-6.164-2.714-6.164-6.06l0,0c0-3.345,2.76-6.058,6.164-6.058l0,0C78.416,136.306,81.177,139.019,81.177,142.363L81.177,142.363z" /></svg>
                            <svg version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 150 150" style={{ enableBackground: 'new 0 0 150 150' }} xmlSpace="preserve" className="circle_decor circle_decor--br"><defs><filter x={0} y={0} width="100%" height="100%" id="dropshadow_1_004" filterUnits="userSpaceOnUse"><feGaussianBlur in="SourceAlpha" stdDeviation={2} /><feOffset dx={-3} dy={0} result="offsetblur" /><feMerge><feMergeNode /><feMergeNode in="SourceGraphic" /><feMergeNode in="SourceGraphic" /></feMerge></filter><filter x={0} y={0} width="100%" height="100%" id="dropshadow_2_004" filterUnits="userSpaceOnUse"><feGaussianBlur in="SourceAlpha" stdDeviation={2} /><feOffset dx={3} dy={0} result="offsetblur" /><feMerge><feMergeNode /><feMergeNode in="SourceGraphic" /><feMergeNode in="SourceGraphic" /></feMerge></filter><clipPath id="circle_decor_mask_004"><circle r="73.5" cx={75} cy={75} /></clipPath></defs><path fill="#55C1AE" d="M74.933,148.5c-9.9,0-19.533-1.95-28.583-5.783c-8.75-3.699-16.6-9-23.333-15.734c-6.75-6.731-12.034-14.582-15.733-23.332C3.45,94.6,1.5,84.967,1.5,75.066c0-9.9,1.95-19.533,5.783-28.583c3.7-8.75,9-16.6,15.733-23.333S37.6,11.116,46.35,7.417c9.05-3.833,18.684-5.783,28.583-5.783c9.901,0,19.534,1.95,28.584,5.783c8.75,3.7,16.6,9,23.332,15.733c6.733,6.733,12.032,14.583,15.733,23.333c3.832,9.067,5.783,18.684,5.783,28.583c0,9.9-1.951,19.534-5.783,28.584c-3.701,8.75-9,16.6-15.733,23.332c-6.732,6.733-14.582,12.033-23.332,15.733C94.467,146.55,84.834,148.5,74.933,148.5z M75,13.783C41.25,13.783,13.783,41.25,13.783,75S41.25,136.217,75,136.217S136.217,108.75,136.217,75S108.75,13.783,75,13.783z" /><circle r="5.8" cx={75} cy="7.8" fillOpacity="0.25" style={{ filter: 'url(#dropshadow_1_004)' }} clipPath="url(#circle_decor_mask_004)" /><circle r="5.8" cx={74} cy="142.5" fillOpacity="0.25" style={{ filter: 'url(#dropshadow_2_004)' }} clipPath="url(#circle_decor_mask_004)" /><path fill="#55C1AE" d="M81.101,7.712c0,3.346-2.761,6.059-6.164,6.059l0,0c-3.404,0-6.164-2.713-6.164-6.059l0,0c0-3.345,2.76-6.058,6.164-6.058l0,0C78.34,1.654,81.101,4.367,81.101,7.712L81.101,7.712z" /><path fill="#55C1AE" d="M81.177,142.363c0,3.346-2.761,6.06-6.164,6.06l0,0c-3.404,0-6.164-2.714-6.164-6.06l0,0c0-3.345,2.76-6.058,6.164-6.058l0,0C78.416,136.306,81.177,139.019,81.177,142.363L81.177,142.363z" /></svg>
                        </div>
                        <div className="container">
                            <div className="row">
                                <div className="col-auto">
                                    <div className="subscribe-form-title-lg">{this.state.footer_newsletter?.title}</div>
                                    <div className="subscribe-form-title-sm">{this.state.footer_newsletter?.description}</div>
                                </div>
                                <div className="col">
                                    <div className="subscribe-form">
                                        <form onSubmit={this.handleSubscribe} >
                                            <div className="form-inline">
                                                <div className="form-control-wrap">
                                                    <input type="email"
                                                        name="subscribe_to"
                                                        value={this.state.subscribe_to}
                                                        onChange={(e) => {
                                                            this.setState({
                                                                "subscribe_to": e.target.value,
                                                                "subscribe_text": "subscribe"
                                                            })
                                                        }}
                                                        className="form-control" placeholder="Type your email..." />
                                                    <svg preserveAspectRatio="none"><rect x={2} y={2} rx={6} height="100%" width="100%" /></svg>
                                                    <span className="bottom" />
                                                </div>
                                                <button type="submit" className="btn btn--lg"
                                                disabled={!this.state.subscribe_to}
                                                >{this.state.subscribe_text}</button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <footer className="page-footer footer-style-3 mt-0">
                        <div className="footer-top footer-top--bg footer--dark">
                            <div className="container">
                                <div className="row">
                                    <div className="col-lg-4">
                                        <div className="footer-block">
                                            <div className="footer-logo">
                                                {/* <a href="index.html" className="logo"><img srcSet="/images/skins/electronics/logo-electronics-footer.png 1x, images/skins/electronics/logo-electronics-footer2x.png 2x" alt="Logo" /></a> */}
                                                <Link to="/" className="logo">
                                                    {/* <img srcSet={`${ this.state.app_site_url }${ this.state.app_site_storage_path }${ this.state.site_logo } `} alt="Logo" style={{
                                                        maxWidth: "25%"
                                                    }} /> */}
                                                    <img srcSet="/images/merchant_bitgofulfill_logo_white.png" alt="Logo" style={{
                                                        maxWidth: "100%",
                                                        width: "100%"
                                                    }} />
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-10">
                                        <div className="footer-block">
                                            <ul className="footer-list-inline">
                                                {
                                                    footer_menus_mapping
                                                }
                                            </ul>
                                        </div>
                                    </div>
                                    <div className="col-lg-4">
                                        <div className="footer-block">
                                            <ul className="social-list">
                                                {
                                                    footer_social_sites_mapping
                                                }
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="footer-bottom footer-bottom--bg">
                            <div className="container text-center">
                                <ul className="payment-link payment-link--sm">
                                    {
                                        footer_payments_mapping
                                    }
                                </ul>
                                <div className="footer-copyright">
                                    {/* <a href="#">FOXshop</a> */}
                                    {this.state.copyright_text}
                                </div>
                            </div>
                        </div>
                    </footer>
                    <div className="footer-sticky">
                        {/*  sticky add to cart */}
                        <div className="sticky-addcart js-stickyAddToCart closed">
                            <div className="container">
                                <div className="row">
                                    <div className="col-auto sticky-addcart_image">
                                        <a href="product.html">
                                            <img src="/images/skins/fashion/products/product-01-1.jpg" alt="" />
                                        </a>
                                    </div>
                                    <div className="col col-sm-5 col-lg-4 col-xl-5 sticky-addcart_info">
                                        <h1 className="sticky-addcart_title">Leather Pegged Pants</h1>
                                        <div className="sticky-addcart_price">
                                            <span className="sticky-addcart_price--actual">$180.00</span>
                                            <span className="sticky-addcart_price--old">$210.00</span>
                                        </div>
                                    </div>
                                    <div className="col-auto sticky-addcart_options  prd-block prd-block_info--style1">
                                        <div className="select-wrapper">
                                            <select className="form-control form-control--sm">
                                                <option value>--Please choose an option--</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-auto sticky-addcart_actions">
                                        <div className="prd-block_qty">
                                            <span className="option-label">Quantity:</span>
                                            <div className="qty qty-changer">
                                                <button className="decrease" />
                                                <input type="number" className="qty-input" defaultValue={1} data-min={1} data-max={1000} />
                                                <button className="increase" />
                                            </div>
                                        </div>
                                        <div className="btn-wrap">
                                            <button className="btn js-prd-addtocart" data-fancybox data-src="#modalCheckOut">Add to cart
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/*added to cart*/}
                        <div className="popup-addedtocart js-popupAddToCart closed" data-close={50000}>
                            <div className="container">
                                <div className="row">
                                    <div className="popup-addedtocart-close js-popupAddToCart-close"><i className="icon-close" /></div>
                                    <div className="popup-addedtocart-cart js-open-drop" data-panel="#dropdnMinicart"><i className="icon-basket" /></div>

                                    {/* <div className="col-auto popup-addedtocart_logo">
                                        <img src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==" data-src="/images/logo-white-sm.png" className="lazyload fade-up" alt="" />
                                    </div> */}

                                    <div className="col popup-addedtocart_info">
                                        <div className="row">
                                            <a href="product.html" className="col-auto popup-addedtocart_image">
                                                <span className="image-container w-100">
                                                    <img className="img" style={{
                                                        height: "100%"
                                                    }} src="/images/skins/fashion/products/product-01-1.jpg" alt="" />
                                                </span>
                                            </a>
                                            <div className="col popup-addedtocart_text">
                                                <a href="product.html" className="popup-addedtocart_title"> </a>
                                                <span className="popup-addedtocart_message">Added to
                                                    &nbsp;
                                                    {/* <a href="cart.html" className="underline">Cart</a> */}
                                                    <Link to="/cart" className="underline" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
                                                        Cart
                                                    </Link>
                                                </span>
                                                <span className="popup-addedtocart_error_message" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-auto popup-addedtocart_actions">
                                        <span>You can continue</span>
                                        {/* <a href="#" className="btn btn--grey btn--sm js-open-drop"
                                            data-panel="#dropdnMinicart">
                                            <i className="icon-basket" />
                                            <span>Check Cart</span>
                                        </a> */}
                                        <Link to="/cart" className="btn btn--grey btn--sm js-open-drop" data-panel="#dropdnMinicart" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
                                            <i className="icon-basket" /><span>Check Cart</span>
                                        </Link>

                                        <span>or</span>
                                        <Link to="/checkout" className="btn btn--invert btn--sm">
                                            <i className="icon-envelope-1" /><span>Check out</span>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/*  select options */}
                        <div className="sticky-addcart popup-selectoptions js-popupSelectOptions closed" data-close={500000}>
                            <div className="container">
                                <div className="row">
                                    <div className="popup-selectoptions-close js-popupSelectOptions-close"><i className="icon-close" /></div>
                                    <div className="col-auto sticky-addcart_image sticky-addcart_image--zoom">
                                        <a href="#" data-caption>
                                            <span className="image-container"><img src="#" alt="" /></span>
                                        </a>
                                    </div>
                                    <div className="col col-sm-5 col-lg-4 col-xl-5 sticky-addcart_info">
                                        <h1 className="sticky-addcart_title"><a href="#">&nbsp;</a></h1>
                                        <div className="sticky-addcart_price">
                                            <span className="sticky-addcart_price--actual" />
                                            <span className="sticky-addcart_price--old" />
                                        </div>
                                        <div className="sticky-addcart_error_message">Error Message</div>
                                    </div>
                                    <div className="col-auto sticky-addcart_options prd-block prd-block_info--style1">
                                        <div className="select-wrapper">
                                            <select className="form-control form-control--sm sticky-addcart_options_select">
                                                <option value="none">Select Option please..</option>
                                            </select>
                                            <div className="invalid-feedback">Can't be blank</div>
                                        </div>
                                    </div>
                                    <div className="col-auto sticky-addcart_actions">
                                        <div className="prd-block_qty">
                                            <span className="option-label">Quantity:</span>
                                            <div className="qty qty-changer">
                                                <button className="decrease" />
                                                <input type="number" className="qty-input" defaultValue={2} data-min={1} data-max={10000} />
                                                <button className="increase" />
                                            </div>
                                        </div>
                                        <div className="btn-wrap">
                                            <button className="btn js-prd-addtocart">Add to cart</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* back to top */}
                        <a className="back-to-top js-back-to-top compensate-for-scrollbar" href="#" title="Scroll To Top">
                            <i className="icon icon-angle-up" />
                        </a>
                        {/* loader */}
                        <div className="loader-horizontal js-loader-horizontal">
                            <div className="progress">
                                <div className="progress-bar progress-bar-striped progress-bar-animated" style={{ width: '100%' }} />
                            </div>
                        </div>
                    </div>
                    {/* payment note */}
                </div>
            </div>
        );
    }
}

export default Footer;